import { h, Component } from 'preact';
import { simpleFormData, resetCaptcha } from '../lib/util';

export default class BookSession extends Component {
  state = { dateObj: {} };

  componentWillMount() {
    this.updateHrDate();
  }

  updateHrDate() {
    const sessionStartTs = this.props.ts;
    return fetch(`${API_HOST}/date/${sessionStartTs}`)
      .then((r) => r.json())
      .then((json) => {
        this.setState({ dateObj: json });
      });
  }

  refCaptcha = (el) => {
    this.captchaEl = el;
  }

  componentDidMount() {
    resetCaptcha(this.captchaEl);
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const formData = simpleFormData(e.target);
    this.bookSession(formData)
      .then(() => {
        this.setState({
          successfulBooking: true
        });
      })
      .catch(() => {
        resetCaptcha(this.captchaEl);
      });
  }

  bookSession(formData) {
    return fetch(`${API_HOST}/sessions`, {
      method: 'POST',
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
      body: formData
    }).then((r) => {
      console.log(r);
      return r;
    });
  }

  render({ ts }, { dateObj }) {
    return (
      <section class="book-session">
        <h3 class="flex flex-middle flex-center flex-wrap">
          Booking&nbsp;&nbsp;<mark>{ dateObj.date } @ { dateObj.time }</mark>
        </h3>
        <form class="form-group" onSubmit={this.handleSubmit}>
          <input name="sessionStartTs" type="hidden" value={ ts } />

          <div class="flex flex-middle">
            <label>Phone *</label>
            <input name="trainee[phone]" placeholder="Your Phone" type="phone" />
          </div>

          <div class="flex flex-middle">
            <label>Name *</label>
            <input name="trainee[name]" placeholder="Your Name" type="text" />
          </div>

          <div class="flex flex-middle">
            <label>Email *</label>
            <input name="trainee[email]" placeholder="Your Email" type="email" />
          </div>

          <div class="flex flex-middle">
            <label>Notes</label>
            <textarea name="trainee[notes]" placeholder="Anything else you'd like to share?"></textarea>
          </div>

          <div class="flex recaptcha">
            <label />
            <div ref={ this.refCaptcha } class="g-recaptcha" data-sitekey="6LdTshIUAAAAADdqSsgCAeRj5V-qQfB98Djqde6U"></div>
          </div>

          <div>
            <button class="btn">Book!</button>
          </div>
        </form>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./components/book-session.js